import { useMutation } from 'react-query';
import { useMicrositeApiContext } from 'contexts/MicrositeApiContext';
import { fetchSharedExaminationJWT } from '@higo/api';

export const useExchangeSharingTokenForJWTMutation = () => {
  const { baseAxios } = useMicrositeApiContext();

  return useMutation(fetchSharedExaminationJWT(baseAxios));
};
